"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _default = (0, _createSvg.createSvg)('IconFocus', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M4.02882095,14.5623116 L7.3223441,11.3291862 C7.71388901,10.9448216 8.3420127,10.9477279 8.72998408,11.3356993 L8.73649739,11.3422126 C9.12342448,11.7291397 9.12342448,12.3564724 8.73649739,12.7433995 C8.73433634,12.7455606 8.73216531,12.7477116 8.72998436,12.7498526 L5.41396642,16.0050602 L8.02882095,16.0050602 C8.5811057,16.0050602 9.02882095,16.4527755 9.02882095,17.0050602 C9.02882095,17.557345 8.5811057,18.0050602 8.02882095,18.0050602 L3.02882095,18.0050602 C2.4765362,18.0050602 2.02882095,17.557345 2.02882095,17.0050602 L2.02882095,12.0050602 C2.02882095,11.4527755 2.4765362,11.0050602 3.02882095,11.0050602 C3.5811057,11.0050602 4.02882095,11.4527755 4.02882095,12.0050602 L4.02882095,14.5623116 Z M16,5.44274859 L12.7064768,8.67587398 C12.3149319,9.0602386 11.6868082,9.05733233 11.2988369,8.66936095 L11.2923236,8.66284765 C10.9053965,8.27592055 10.9053965,7.64858779 11.2923236,7.2616607 C11.2944846,7.25949965 11.2966556,7.25734862 11.2988366,7.25520766 L14.6148545,4 L12,4 C11.4477153,4 11,3.55228475 11,3 C11,2.44771525 11.4477153,2 12,2 L17,2 C17.5522847,2 18,2.44771525 18,3 L18,8 C18,8.55228475 17.5522847,9 17,9 C16.4477153,9 16,8.55228475 16,8 L16,5.44274859 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));

exports.default = _default;